import { Howl } from "howler";
import { SoundManager } from "./SoundManager";
import { SpriteConfig } from "./Config";

export class BaseSound {
    public url: string;
    public source: Howl;

    private manager: SoundManager;

    constructor(manager: SoundManager, config?: SpriteConfig) {
        this.manager = manager;

        config = config || { urls: "" };

        let url = config.urls;

        if (typeof url !== "string" && typeof url !== "object") {
            SoundManager.warn("BaseSoundAsset: config.src");
        }

        if (typeof url === "object") {
            const preffered = SoundManager.getPreferedSrcFormat(url);
            if (!preffered) SoundManager.warn("BaseSoundAsset: no supported source format found.");
            else url = preffered;
        }

        this.url = this.manager.config.baseUrl + this.manager.config.manifestRoot + url;

        const howlConfig: IHowlProperties = {
            src: this.url,
            sprite: config.sprite,
            preload: false
        };

        this.source = new Howl(howlConfig);
    }

    getName() {
        return this.url //
            .slice(this.url.lastIndexOf("/") + 1, this.url.length)
            .replace(/\.[^/.]+$/, "");
    }
}
